// extracted by mini-css-extract-plugin
export var externalLink = "_d2-0";
export var internalLinkLabel = "_d2-1";